import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ImageViewer = ({ src, onClose, closeOnClickOutside }) => {
  const [isPortrait, setIsPortrait] = useState(true);

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.currentTarget;
    setIsPortrait(naturalHeight > naturalWidth);
  };

  return (
    <Dialog
      open={!!src}
      onClose={closeOnClickOutside ? onClose : undefined}
      maxWidth={false}
      fullWidth
      fullScreen
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.9)', // Darker backdrop
        },
        onClick: onClose,
      }}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: 'transparent',
        },
        '& .MuiDialog-container': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'stretch',
          height: '100vh',
          width: '100vw',
        },
      }}
    >
      <DialogContent
        sx={{
          backgroundColor: 'transparent',
          position: 'relative',
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
        }}
        onClick={() => {
          if (closeOnClickOutside) {
            onClose();
          }
        }}
      >
        <div
          style={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              width: '30px',
              height: '30px',
              right: '15px',
              top: '15px',
              color: 'black',
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'white',
              },
              zIndex: 2147483647,
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            onClick={(e) => e.stopPropagation()}
            src={src}
            alt="Zoomed"
            style={{
              maxWidth: isPortrait ? '80vw' : '90vw',
              maxHeight: isPortrait ? '45vh' : '80vh',
              width: 'auto',
              height: 'auto',
            }}
            onLoad={handleImageLoad}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewer;
